// Core
import styled from 'styled-components';

// Component
import { QuantityStatus } from './QuantityCard.types';

export const Container = styled.div`
  align-items: center;
  background-color: ${({ theme }) => (theme.color.quantityCard.backgroundColor)};
  border-radius: 4px;
  display: flex;
  height: 39px;
  padding: 8px 10px 8px 8px;
  width: 100%;
  position: relative;
`;

export const QuantityContainer = styled.div<{ status: QuantityStatus }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme, status }) => (status === QuantityStatus.neutral
    ? theme.color.quantityCard.quantityNeutralBgColor
    : theme.color.quantityCard.quantityBackgroundColor)};
  border-radius: 2px;
  display: flex;
  height: 23px;
  justify-content: center;
  width: 23px;
`;

export const DescriptionContainer = styled.div`
  margin-left: 8px;
  max-width: 100%;
  overflow: hidden;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  min-width: 0;
`;
